import type { ActivityCenterStore } from "@/Modules/ActivityCenter/Store";
import type { UpdateNotificationStatusQuery } from "@/Modules/Models/Api/ActivityCenter";

import ActivityCenterApiConnector from "@/Services/TherapyApi/ActivityCenter";

import { log } from "@/Utils/Debug";

class UpdateNotificationsActionHandler {
  constructor(
    private readonly activityCenterStore: ActivityCenterStore,
    private readonly activityCenterApiConnector: ActivityCenterApiConnector = new ActivityCenterApiConnector()
  ) {}

  public async handle(updateNotificationsQuery: UpdateNotificationStatusQuery[]) {
    this.activityCenterStore.isLoading = true;

    try {
      await this.activityCenterApiConnector.updateNotifications(updateNotificationsQuery);
    } catch (error) {
      log("Error updating notifications", error);
    } finally {
      this.activityCenterStore.isLoading = false;
    }
  }
}

export default UpdateNotificationsActionHandler;
